import service from './axios';

// 获取回收表单列表
export const fetchRecycleFormList = (params) => {
  return service({
    method: 'get',
    url: '/manage/recycle/forms',
    params
  });
};

// 获取回收表单详情
export const fetchRecycleFormDetail = (id) => {
  return service({
    method: 'get',
    url: `/manage/recycle/forms/${id}`
  });
};

// 审核回收表单
export const auditRecycleForm = (id, data) => {
  return service({
    method: 'post',
    url: `/manage/recycle/forms/${id}/audit`,
    data
  });
};

// 标记回收表单为已到店
export const markRecycleFormAsArrived = (id) => {
  return service({
    method: 'post',
    url: `/manage/recycle/forms/${id}/mark-arrived`
  });
};